import { Component, OnInit } from '@angular/core';
import { ActivityLogsService } from '../services/activity-logs.service';
import { DataSharedService } from '../services/data-shared.service';
import * as moment from 'moment';

@Component({
  selector: 'app-activity-logs',
  templateUrl: './activity-logs.component.html',
  styleUrls: ['./activity-logs.component.css']
})
export class ActivityLogsComponent implements OnInit {

  public loading: boolean = false;
  public activityLogs: any = [];
  totalCount: number = 0;
  searchText: string = '';
  selectedAction: string = '';
  selectedDate: string = '';
  selectedMonth: string | null = null;
  selectedYear: number | null = null;
  years: number[] = [];
  months: any[] = [];
  actionLabels: any = {};
  actionOptions: any[] = [];
  today: string = '';

  constructor(
    public activityLogsService: ActivityLogsService,
    public dataSharedService: DataSharedService,
  ) { }

  ngOnInit(): void {
    const now = moment();
    this.months = this.dataSharedService.getMonths();
    this.years = this.dataSharedService.getYears();
    this.selectedMonth = now.format('MM');
    this.selectedYear = +now.format('YYYY');
    this.today = now.format('YYYY-MM-DD');
    this.selectedDate = this.today;

    this.actionOptions = [
      { value: 'login', label: 'Login' },
      { value: 'logout', label: 'Logout' },
      { value: 'job_created', label: 'Job Created' },
      { value: 'job_updated', label: 'Job Updated' },
      { value: 'job_assigned', label: 'Job Assigned' },
      { value: 'timesheet_submitted', label: 'Timesheet Submitted' },
      { value: 'timesheet_approved', label: 'Timesheet Approved' },
      { value: 'timesheet_rejected', label: 'Timesheet Rejected' },
      { value: 'page_visited', label: 'Page Visited' },
    ];

    this.getActivityLogs(1);
  }

  getActivityLogs(page: number) {
    this.loading = true;
    const params: any = {
      page,
      search: this.searchText || undefined,
      action: this.selectedAction || undefined,
      date: this.selectedDate || undefined,
      month: this.selectedMonth,
      year: this.selectedYear,
    };

    this.activityLogsService.getActivityLogs(page, params).subscribe((response: any) => {
      this.loading = false;
      this.activityLogs = response.data;
      this.totalCount = response.meta.total;
    }, () => {
      this.loading = false;
    });
  }

  onStepChange(event: any) {
    this.getActivityLogs(event);
  }

  onSearch() {
    this.getActivityLogs(1);
  }

  onFilterChange() {
    this.getActivityLogs(1);
  }

  onMonthYearChange() {
    this.selectedDate = '';
    this.getActivityLogs(1);
  }

  onDateChange() {
    if (this.selectedDate) {
      const date = moment(this.selectedDate);
      this.selectedMonth = date.format('MM');
      this.selectedYear = +date.format('YYYY');
    }
    this.getActivityLogs(1);
  }

  clearDateFilter() {
    this.selectedDate = '';
    const now = moment();
    this.selectedMonth = now.format('MM');
    this.selectedYear = +now.format('YYYY');
    this.getActivityLogs(1);
  }

  getActionBadgeClass(action: string): string {
    const badgeMap: any = {
      'login': 'bg-success text-success',
      'logout': 'bg-dark text-dark',
      'job_created': 'bg-primary text-primary',
      'job_updated': 'bg-info text-info',
      'job_assigned': 'bg-warning text-warning',
      'timesheet_submitted': 'bg-primary text-primary',
      'timesheet_approved': 'bg-success text-success',
      'timesheet_rejected': 'bg-tertiary text-tertiary',
      'page_visited': 'bg-dark text-dark',
    };
    return badgeMap[action] || 'bg-secondary text-secondary';
  }

  getActionIcon(action: string): string {
    const iconMap: any = {
      'login': 'bi-box-arrow-in-right',
      'logout': 'bi-box-arrow-right',
      'job_created': 'bi-plus-circle-fill',
      'job_updated': 'bi-pencil-fill',
      'job_assigned': 'bi-person-check-fill',
      'timesheet_submitted': 'bi-stopwatch-fill',
      'timesheet_approved': 'bi-check-circle-fill',
      'timesheet_rejected': 'bi-x-circle-fill',
      'page_visited': 'bi-eye-fill',
    };
    return iconMap[action] || 'bi-circle-fill';
  }

  getActionLabel(action: string): string {
    const found = this.actionOptions.find(a => a.value === action);
    return found ? found.label : action;
  }
}
